import {FC} from "react";
import {Box} from "@mui/material";


export interface VimeoProps {
    /** Vimeo id */
    id: string;
    /** Skip to a time in the video */
    // skipTo?: {
    //     h?: number;
    //     m: number;
    //     s: number;
    // };
    /** Auto play the video */
    autoPlay?: boolean;
}

export function Vimeo({id, autoPlay}: VimeoProps) {


    const vimeoId = id


    return <div>
        <Box sx={{
            position: "relative",
            paddingBottom: "56.25%"
        }}>
            <iframe
                title={`vimeo-${vimeoId}`}
                src={`https://player.vimeo.com/video/${vimeoId}?autoplay=${autoPlay}`}
                allow='autoplay; fullscreen'
                allowFullScreen
                style={{
                    position: "absolute",
                    border: 0,
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                }}
            />
        </Box>
    </div>
}
